export default __webpack_public_path__ + "static/media/KingLock.8808fe13.png";